import { render, staticRenderFns } from "./ProFeature.vue?vue&type=template&id=354a5746"
import script from "./ProFeature.vue?vue&type=script&lang=js"
export * from "./ProFeature.vue?vue&type=script&lang=js"
import style0 from "./ProFeature.vue?vue&type=style&index=0&id=354a5746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports